// extracted by mini-css-extract-plugin
export var alert = "cT_hV";
export var error = "cT_hW";
export var text = "cT_c4";